import * as PIXI from 'pixi.js';
import { ColorMatrixFilter } from '@pixi/filter-color-matrix';
import { Config } from '../../video-data/config';
import { ColorAttribute } from '../attributes';
import { rgb2int } from '../../libs/videoData';
import type { BaseSettings } from '../TimeAwareBase';
import { Filter } from './Filter';

/**
 *  Creates "duotone" effect remapping the color spectrum between two arbitrary colors
 */
export class DuoToneFilter extends Filter {
    override _classType = Config.DUO_TONE_FILTER;
    override pixiFilter: ColorMatrixFilter;

    @ColorAttribute()
    accessor firstColor = rgb2int([0, 0, 0]);
    @ColorAttribute()
    accessor secondColor = rgb2int([255, 255, 255]);

    constructor(settings: BaseSettings) {
        super(settings);
        this.pixiFilter = new ColorMatrixFilter();
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(['firstColor', 'secondColor']);
    }

    override _update() {
        const firstColor = PIXI.Color.shared.setValue(this.firstColor).toRgbArray();
        const secondColor = PIXI.Color.shared.setValue(this.secondColor).toRgbArray();
        this.pixiFilter.matrix = [
            firstColor[0] - secondColor[0],
            0,
            0,
            0,
            secondColor[0],
            firstColor[1] - secondColor[1],
            0,
            0,
            0,
            secondColor[1],
            firstColor[2] - secondColor[2],
            0,
            0,
            0,
            secondColor[2],
            0,
            0,
            0,
            1,
            0,
        ];
    }
}
